import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskQuotaManage() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    let location = useLocation();

    let MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);

    // 표에 뿌려줄 tableBodyData
    const [combineData, setCombineData] = useState([]);
    const [combineList, setCombineList] = useState([]);

    const [reload, setReload] = useState(false);
    const [listState, setListState] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    const productList = ["노트북", "기능성 속옷", "중고명품", "의료기", "수산물", "공기청정기", "홍삼", "가전제품"];

    useEffect(() => {
        dispatch(change_Current_Location("할부관리"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "할부관리",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    // 날짜 선택 로직 ...
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    useEffect(() => {
        ListData();
    }, [reload, page]);

    const ListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/rm/trx", {
                params: {
                    page: page,
                    // ...필요한 파라미터
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp);
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const tableHeaderData = [
        { no: 1, text: "시간", width: "130px", textAlign: "center" },
        { no: 2, text: "가맹점", width: "170px", textAlign: "center" },
        { no: 3, text: "카드", width: "50px", textAlign: "center" },
        { no: 4, text: "할부개월", width: "70px", textAlign: "center" },
        { no: 5, text: "금액", width: "80px", textAlign: "center" },
        { no: 6, text: "승인번호", width: "90px", textAlign: "center" },
    ];

    // ─────────────────────────────────────────────────────────────
    // (★) data.trx_date가 "오늘"인 경우에만 배경색을 주기 위해
    //     rowData에 isToday 속성을 추가하는 부분
    // ─────────────────────────────────────────────────────────────
    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData?.trx ?? [];
            setCombineList(list);

            for (let i = 0; i < list.length; i++) {
                let data = list[i];
                let metadataObj = {};
                let productObj = [];

                try {
                    metadataObj = JSON.parse(data?.metadata || "{}");
                    productObj = JSON.parse(data?.product || "[]");
                } catch (e) {
                    console.error("파싱 오류:", e);
                }

                // rowData에는 각 셀 정보의 배열
                let rowData = [
                    {
                        no: 1,
                        text: data.trx_date,
                        width: "130px",
                        textAlign: "center",
                    },
                    {
                        no: 2,
                        text: data.co_nm,
                        width: "170px",
                        textAlign: "left",
                    },
                    {
                        no: 3,
                        text: data.card,
                        width: "50px",
                        textAlign: "center",
                    },
                    {
                        no: 4,
                        text: data?.quota === "00" ? "일시불" : data?.quota ?? "",
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: changeNum(data.amt),
                        width: "80px",
                        textAlign: "right",
                    },
                    {
                        no: 6,
                        text: data.approval_id,
                        width: "90px",
                        textAlign: "center",
                    },
                ];
                rowData.id = data.id;

                const isToday = dayjs("20" + data.trx_date, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD");

                if (isToday) {
                    rowData.isToday = true;
                }

                tableBodyData.push(rowData);
            }
            setListState((e) => !e);
            setCombineData(tableBodyData);
        }
    }, [listData]);

    const getDisplayTime = (regDate) => {
        const now = new Date();
        const dateObj = new Date(regDate);
        const kstDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000);
        const diffMs = now - kstDate;

        const diffMinutes = Math.floor(diffMs / 1000 / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) return `${diffMinutes}분`;
        if (diffHours < 24) return `${diffHours}시간`;
        return `${diffDays}일`;
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div style={{ width: "100%", maxWidth: "600px" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            // 여기서는 totalCount 용도로만 tableBodyData를 넘기고 있긴 하지만
                            // Page 컴포넌트가 필요로 하므로 그대로 둠
                            tableBodyData={listData?.totCnt ?? []}
                            // 실제 렌더링할 데이터를 filter_tableBodyData 로 넘김
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RiskQuotaManage